import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { distinctUntilChanged, Subscription, zip } from 'rxjs';
import { MultiSelectSearchFormFieldComponent } from '../../../../../shared/components/multi-select-search-form-field/multi-select-search-form-field.component';
import {
  IDataOperacion,
  IOperacionGuardado,
  IOperacionSelected,
} from '../../../../../shared/interfaces/operaciones.interface';
import { TabTratamientoService } from '../../../../../shared/services/tab-tratamiento.service';

@Component({
  selector: 'soph-operaciones',
  standalone: true,
  imports: [
    CommonModule,
    MultiSelectSearchFormFieldComponent,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
  ],
  templateUrl: './operaciones.component.html',
  styleUrl: './operaciones.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperacionesComponent {
  formOperaciones: FormGroup;
  operacionesOptions = signal<Array<IDataOperacion>>([]);
  operOptions: IDataOperacion[] = [];
  idsOperacionSelected: string[] = [];
  operacionesSelected: IOperacionSelected[] = [];
  operacionesGuardados: IOperacionGuardado[] = [];
  subs: Subscription = new Subscription();

  get operaciones() {
    return this.formOperaciones.get('operaciones')!;
  }

  constructor(private fb: FormBuilder, private tabTratamientoService: TabTratamientoService) {
    this.formOperaciones = this.fb.group({
      operaciones: [''],
    });

    this.operaciones?.valueChanges.pipe(distinctUntilChanged()).subscribe((values: string[]) => {
      this.onOperacionSelected(values);
      this.showOperacionesGuardadas();
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
  ngOnInit(): void {
    this.llamarServicios();
  }

  setOriginalValues(operaciones: string[]) {
    this.operaciones.setValue(operaciones);
  }

  llamarServicios() {
    const subscribes = zip(this.tabTratamientoService.getOperaciones()).subscribe({
      next: ([operaciones]) => {
        this.operacionesOptions.set(operaciones);
        this.operOptions = operaciones;
      },
    });
    this.subs.add(subscribes);
  }

  showOperacionesGuardadas() {
    const data = this.operaciones.value as string[];
    this.operacionesGuardados = [];

    if (data && data.length > 0) {
      data.forEach((item) => {
        const operimiento = this.operacionesOptions().find((o) => o.idOperacion === item);
        if (
          operimiento &&
          !this.operacionesGuardados.some((p) => p.idOperacion === operimiento.idOperacion)
        ) {
          this.operacionesGuardados.push(operimiento);
        }
      });
    }
  }

  resetForm() {
    this.formOperaciones.reset();
  }

  armarRequestOperaciones(): string[] {
    if (this.operaciones.value && this.operaciones.value.length > 0) {
      return this.operaciones.value;
    } else {
      return [];
    }
  }

  disableSelectorOperaciones() {
    this.operaciones.disable();
  }

  enableSelectorOperaciones() {
    this.operaciones.enable();
  }

  unselectOperacion(idTerapia: string) {
    const terapias = this.operaciones.value;
    const newTerapias = terapias.filter((t: string) => t !== idTerapia);
    this.operaciones.setValue(newTerapias);
  }

  onOperacionSelected(idsOperacionEmitidos: string[]) {
    this.operacionesSelected = [];
    if (idsOperacionEmitidos) {
      idsOperacionEmitidos.forEach((id) => {
        const oper = this.operOptions.find((oper) => oper.idOperacion === id);
        if (oper) {
          this.operacionesSelected.push(oper);
        }
      });
    }
  }
}
